"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_TICKET_STATUSES = exports.SUPPORT_VISIBLE_EXCHANGE_STATUSES = exports.SUPPORT_VISIBLE_WITHDRAWAL_STATUSES = exports.TemporaryPasswordResponseSchema = exports.UpdateStaffRequestSchema = exports.CreateStaffRequestSchema = exports.StaffListResponseSchema = exports.StaffSchema = void 0;
const zod_1 = require("zod");
const auth_1 = require("./auth");
exports.StaffSchema = auth_1.StaffProfileSchema;
exports.StaffListResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.StaffSchema) });
exports.CreateStaffRequestSchema = zod_1.z.object({
    email: auth_1.StaffEmailSchema,
    name: zod_1.z.string().trim().min(1).max(100),
    role: auth_1.StaffRoleSchema,
});
exports.UpdateStaffRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(100).optional(),
    status: auth_1.StaffStatusSchema.optional(),
    role: auth_1.StaffRoleSchema.optional(),
})
    .refine((body) => body.name !== undefined || body.status !== undefined || body.role !== undefined, {
    message: 'Nothing to update',
});
/** Returned once, on creation and on reset; never stored or logged. */
exports.TemporaryPasswordResponseSchema = zod_1.z.object({
    staff: exports.StaffSchema,
    temporaryPassword: zod_1.z.string(),
    expiresAt: zod_1.z.iso.datetime(),
});
/**
 * What a `support` member sees outside the Support section (spec 2026-10-28 §2, §5.3): these
 * operation statuses for anyone, plus everything of a user who has a ticket in one of these states.
 */
exports.SUPPORT_VISIBLE_WITHDRAWAL_STATUSES = ['failed', 'rejected', 'expired'];
exports.SUPPORT_VISIBLE_EXCHANGE_STATUSES = ['failed', 'payment_failed', 'expired'];
exports.ACTIVE_TICKET_STATUSES = ['open', 'pending'];
//# sourceMappingURL=staff.js.map